import { SliceZone } from "@prismicio/react";

type SliceLike = {
  primary?: {
    // Prismic Boolean fields default to `false`, but can also come back as
    // `null`/`undefined` when never toggled. All of those mean "visible".
    hidden?: boolean | null;
  } | null;
};

/**
 * Removes slices whose `primary.hidden` boolean is truthy.
 *
 * This is the single source of truth for the "hidden" slice behavior. Use it
 * (or `VisibleSliceZone`, which wraps it) anywhere slices are rendered —
 * including nested slice zones such as reusable content — so hidden slices are
 * consistently filtered at every level.
 */
export function filterVisibleSlices<T extends SliceLike>(
  slices: T[] | null | undefined,
): T[] {
  return (slices ?? []).filter((slice) => !slice?.primary?.hidden);
}

/**
 * A drop-in replacement for `@prismicio/react`'s `SliceZone` that first filters
 * out slices marked as hidden. Prefer this over `SliceZone` so the hidden
 * behavior can't be accidentally bypassed in a new render path.
 */
export function VisibleSliceZone({
  slices,
  components,
  context,
}: {
  slices: any[] | null | undefined;
  components: any;
  context?: any;
}) {
  return (
    <SliceZone
      slices={filterVisibleSlices(slices)}
      components={components}
      context={context}
    />
  );
}
